import {autorun} from 'mobx';
import {useEffect} from 'react';

import {userStore} from '@/entities/user';
import {DEBUG, LOG_LEVEL} from '@/shared/config';
import {init as rollbarInit, setUser} from '@/shared/lib/rollbar';
import {logger, RollbarTransport} from '@/shared/services/logger';

export function useRollbar() {
  useEffect(() => {
    const cypressEnv = typeof window !== 'undefined' && Boolean(window.Cypress);

    const rollbar = rollbarInit({enabled: !cypressEnv && !DEBUG});
    logger.use(
      new RollbarTransport({
        instance: rollbar,
        level: LOG_LEVEL,
      })
    );

    return autorun(() => {
      const userId = userStore.userData?.id ?? null;

      setUser({
        id: userId,
      });
    });
  }, []);
}
